import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FoehnNotfoundComponent, GesdemConfirmationComponent, GesdemErrorComponent, gesdemLoaderGuard } from '@dsivd/prestations-ng';

import { canActivateLegalRep } from './guards/legal-representative-gard.service';
import { PageWrapperComponent } from './page-wrapper/page-wrapper.component';
import { InformationApplicantPageComponent } from './pages/information-applicant-page/information-applicant-page.component';
import { LegalRepresentativePageComponent } from './pages/legal-representative-page/legal-representative-page.component';
import { ProfessionalProjectPageComponent } from './pages/professional-project-page/professional-project-page.component';
import { RequestOriginPageComponent } from './pages/request-origin-page/request-origin-page.component';
import { RequestProcurationPageComponent } from './pages/request-procuration-page/request-procuration-page.component';
import { RequestSummaryPageComponent } from './pages/request-summary-page/request-summary-page.component';

/**
 * ========> You must respect this structure:
 * - routes const MUST be an array of Route
 * - The main Route MUST be linked to a component
 * - The main Route MUST contain a 'children' node
 * - Each child of the 'children' node CAN contain an 'order' parameter in the data attribute
 * - You MUST identify the main route in the children by giving 'data' a 'main' attribute that evaluates to 'true'
 * - The main identified route, if connected to gesdem must define canActivate: [GesdemLoaderGuard],
 */

const routes: Routes = [
    {
        path: '',
        component: PageWrapperComponent,
        data: { root: true },
        children: [
            { path: '', component: RequestOriginPageComponent, canActivate: [gesdemLoaderGuard] },
            { path: '404', component: FoehnNotfoundComponent },
            { path: 'erreur', component: GesdemErrorComponent },
            {
                path: ':reference',
                children: [
                    {
                        path: 'request-origin',
                        component: RequestOriginPageComponent,
                        data: { order: 1 }
                    },
                    {
                        path: 'information-applicant',
                        component: InformationApplicantPageComponent,
                        data: { order: 2 }
                    },
                    {
                        path: 'legal-representative',
                        component: LegalRepresentativePageComponent,
                        canActivate: [canActivateLegalRep],
                        data: { order: 3 }
                    },
                    {
                        path: 'professional-project',
                        component: ProfessionalProjectPageComponent,
                        data: { order: 4 }
                    },
                    {
                        path: 'procuration',
                        component: RequestProcurationPageComponent,
                        data: { order: 5 }
                    },
                    {
                        path: 'request-summary',
                        component: RequestSummaryPageComponent,
                        data: { order: 6 }
                    },
                    {
                        path: 'confirmation',
                        component: GesdemConfirmationComponent,
                        data: {
                            order: 7,
                            hasEmailSent: true,
                            // To download the right PDF
                            currentEtape: 1
                        }
                    },
                    { path: 'erreur', component: GesdemErrorComponent },
                    { path: '404', component: FoehnNotfoundComponent },
                    { path: '', redirectTo: 'request-origin', pathMatch: 'full' },
                ],
                canActivate: [gesdemLoaderGuard]
            },
            { path: '**', redirectTo: '/404', pathMatch: 'full' },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
